import { Button, Spin } from "antd";
import { useProjectDetailsStore } from "modules/organization/store";
import { useRankingProjectListStore } from "modules/organization/store/rankingProjectListStore";
import { LeftOutlined } from "@ant-design/icons";
import { RBAC } from "auth/rbac/rbac";
import { ERbacPermissions } from "auth/rbac/rbacPermissionsList";
import ErrorBoundary from "modules/shared/components/ErrorBoundary";
import PageLoader from "modules/shared/components/PageLoader";
import { usePageTitle } from "modules/shared/hooks";
import { FC, Fragment } from "react";
import { Link } from "react-router-dom";
import { useOrganizationRoutes } from "routes/organizationRoute";
import RankingProjectCardList from "./components/RankingProjectCardList";
import OrgCreateEditRankingProject from "./components/OrgCreateEditRankingProject";

const OrgRankingProjectsPage: FC<{}> = () => {
  const { organizationBaseRouteUrl } = useOrganizationRoutes();
  const { projectDetails, isLoadingProjectDetails } = useProjectDetailsStore();
  const { setRankingProjectDrawerState, setRankingProjectDrawerOptions } =
    useRankingProjectListStore();

  usePageTitle(
    `MonQcle - ${
      projectDetails
        ? projectDetails?.title + " - Ranking Projects"
        : "Ranking Projects"
    }`,
  );

  return (
    <ErrorBoundary>
      <Fragment>
        {isLoadingProjectDetails ? (
          <PageLoader />
        ) : (
          <Spin spinning={false}>
            {projectDetails && (
              <Fragment>
                <div className="pageTopSection">
                  <div className="backLink">
                    <Link
                      to={
                        organizationBaseRouteUrl +
                        `/project/${projectDetails?.slug}`
                      }
                    >
                      <LeftOutlined role="img" aria-label="" />
                      Back to Project Home
                    </Link>
                  </div>
                </div>
                <div className="pageHeadingWrap">
                  <h2 id="tab-header">
                    Ranking Projects for {projectDetails?.title ?? ""}
                  </h2>
                  <RBAC
                    allowedPermissions={[
                      ERbacPermissions.ORG_RANKING_PROJECT_MANAGE,
                    ]}
                    project_role_id={projectDetails?.project_role_id}
                    direct_permissions={[
                      ERbacPermissions.ORG_RANKING_PROJECT_MANAGE,
                    ]}
                  >
                    <Button
                      type="primary"
                      className="flexLeftGap"
                      onClick={() => {
                        setRankingProjectDrawerOptions();
                        setRankingProjectDrawerState(true);
                      }}
                    >
                      Create Ranking Project
                    </Button>
                  </RBAC>
                </div>
                <ErrorBoundary>
                  <RankingProjectCardList />
                </ErrorBoundary>
                <OrgCreateEditRankingProject />
              </Fragment>
            )}
          </Spin>
        )}
      </Fragment>
    </ErrorBoundary>
  );
};

export default OrgRankingProjectsPage;
